import React, { Fragment, useState, useEffect } from "react";
import {
  Col,
  Card,
  CardHeader,
  Row,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  Label,
  Input,
  FormGroup,
  ModalFooter,
} from "reactstrap";
import CountUp from "react-countup";
import { H6, Image, LI, UL } from "../../../../AbstractElements";
import { FiEdit2 } from "react-icons/fi";
import RequiredField, {
  BOD,
  ContactUs,
  ContactUsNumber,
  DDMMYY,
  Designer,
  Email,
  FirstName,
  LastName,
  Submit,
  Cancel,
  BirthDate,
  Age,
  MobileNo,
  ContactNo,
  ContactRelation,
  Gender,
  Address,
  Location,
  Contact,
} from "../../../../Constant";
import { useForm, Controller } from "react-hook-form";
import {
  ProfileChangePassword,
  ProfileUpdate,
  UpdateDoctor,
  UpdatePatient,
  UpdateStaff,
} from "../../../../apiController";
import { toast } from "react-toastify";

const UserProfile = () => {
  const [url, setUrl] = useState("");
  const [edit, setEdit] = useState(false);
  const [code, setCode] = useState(false);
  const [modal, setModal] = useState(false);
  const {
    control,
    handleSubmit,
    watch,
    register,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const [formdata, setFormdata] = useState({});
  const [base64, setBase64] = useState("");

  const [age, setAge] = useState("");

  const dob = watch("birthday");

  const [isSubmitting, setIsSubmitting] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };
  const toggleCancel = () => {
    setModal(!modal);
    setEdit(!edit);
  };

  const password = watch("newPassword");

  const userdata = JSON.parse(localStorage.getItem("userdata") ?? "{}");
  const membersdata = localStorage.getItem("members") ?? "[]";

  const memData = JSON.parse(membersdata);
  // console.log(memData)

  const user = userdata.user;
  console.log(user);

  const userId = user.role_id;

  console.log(userId);

  const isInvalidUserId =
    userId === null ||
    userId === undefined ||
    userId === "" ||
    Number.isNaN(userId);
  console.log(isInvalidUserId);

  const readUrl = (event) => {
    if (event.target.files.length === 0) return;
    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      setUrl(reader.result);
    };
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64(reader.result);
        setValue("image", reader.result); // Set base64 string in form
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (dob) {
      const dobDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - dobDate.getFullYear();
      const monthDiff = today.getMonth() - dobDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < dobDate.getDate())
      ) {
        age--;
      }
      setAge(age);
      setValue("age", age);
    }
  }, [dob, setValue]);

  const handleEdit = () => {
    setEdit(!edit);
    setModal(!modal);
    // if(userId === )
    setValue("image", user.image);
    setValue("firstName", user.first_name);
    setValue("lastname", user.surname);
    setValue("phone", user.phone);
    setValue("email", user.email);
    setValue("gender", user.gender);
    setValue("birthday", user.dob);
    setValue("age", user.age);
    setValue("address", user.address);
    setValue("qualification", user.qualification);
    setValue("aadharnumber", user.aadhar_number);
    setValue("relation", user.relationship);
    setValue("contactnumber", user.contact_mobile);
    setValue("contactname", user.primary_contact_name);
    setValue("id", user.id);
  };

  const onSubmit = (data) => {
    const formattedData = {
      image: data.image,
      first_name: data.firstName,
      surname: data.lastname,
      patient_reg_no: data.regno,
      phone: data.phone,
      email: data.email,
      age: data.age,
      dob: data.birthday,
      gender: data.gender,
      profession: data.profession,
      qualification: data.qualification,
      primary_contact_name: data.contactname,
      relationship: data.relation,
      contact_mobile: data.contactnumber,
      address: data.address,
      aadhar_number: data.aadharnumber,
      id: data.id,
    };

    if (!edit) {
      console.log(user.id);
      const formdata = {
        patient_id: user.id,
        id: user.id,
        password: data.newPassword,
        confirm_password: data.confirmPassword,
      };

      console.log(formdata);
      changePassword(formdata);
    } else if (edit && !isInvalidUserId && userId === 1) {
      updateAdminProfile(formattedData)
      console.log("ADMIN", formattedData);
    } else if (edit && !isInvalidUserId && userId === 2) {
      updateAdminProfile(formattedData)
      console.log("Doctor", formattedData);
    } else if (edit && !isInvalidUserId && userId === 3) {
      updateAdminProfile(formattedData)
      console.log("Staff", formattedData);
    } else if (edit && !isInvalidUserId && userId === 4) {
      updatePatientProfile(formattedData)
      console.log("Patient", formattedData);
    }
  };

  const changePassword = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await ProfileChangePassword(formData);
      if (response.status === true) {
        toast.success("Updated Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      reset();
      toggle();
      setIsSubmitting(false);
    }
  };
  const updateAdminProfile = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await ProfileUpdate(formData);
      if (response.status === true) {
        toast.success("Updated Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      reset();
      toggle();
      setIsSubmitting(false);
    }
  };

  const updateDoctorProfile = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await UpdateDoctor(formData);
      if (response.status === true) {
        toast.success("Updated Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      reset();
      toggle();
      setIsSubmitting(false);
    }
  };
 

  const updatePatientProfile = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await UpdatePatient(formData);
      if (response.status === true) {
        toast.success("Updated Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      reset();
      toggle();
      setIsSubmitting(false);
    }
  };

  return (
    <Fragment>
      <Col sm="12">
        <Card className="hovercard text-center">
          <CardHeader></CardHeader>
          {/* <CardHeader className='cardheader'></CardHeader> */}
          <div className="user-image">
            <div className="avatar">
              <Image
                attrImage={{
                  className: "step1",
                  alt: "",
                  src: `${url ? url : user.image}`,
                }}
              />
              {/* <Image attrImage={{ className: 'step1', alt: '', src: `${url ? url : require('../../../../assets/images/user/7.jpg')}` }} /> */}
            </div>
            {/* <div className='icon-wrapper step2' data-intro='Change Profile image here'>
              <i className='icofont icofont-pencil-alt-5' onChange={(e) => readUrl(e)}>
                <input className='upload' type='file' onChange={(e) => readUrl(e)} />
              </i>
            </div> */}
          </div>
          <div className="info">
            <Row className="step3" data-intro="This is the your details">
              <Col sm="6" lg="4" className="order-sm-1 order-xl-0">
                <Row>
                  <Col md="6">
                    <div className="ttl-info text-start">
                      <H6>
                        <i className="fa fa-envelope me-2"></i> {Email}
                      </H6>
                      <span>{user.email ? user.email : "N/A"}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="ttl-info text-start ttl-sm-mb-0">
                      <H6>
                        <i className="fa fa-calendar me-2"></i>
                        {BOD}
                      </H6>
                      <span>{user.dob}</span>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col sm="12" lg="4" className="order-sm-0 order-xl-1">
                <div className="user-designation">
                  <div className="title">
                    <a target="_blank" href="#javascript">
                      {`${user.first_name} ${user.surname}`}
                    </a>
                  </div>
                  <div className="desc mt-2">
                    {user.profession ? user.profession : null}
                  </div>
                </div>
              </Col>
              <Col sm="6" lg="4" className="order-sm-2 order-xl-2">
                <Row>
                  <Col md="6">
                    <div className="ttl-info text-start ttl-xs-mt">
                      <H6>
                        <i className="fa fa-phone me-2"></i>
                        {Contact}
                      </H6>
                      <span>{user.phone}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="ttl-info text-start ttl-sm-mb-0">
                      <H6>
                        <i className="fa fa-location-arrow me-2"></i>
                        {Location}
                      </H6>
                      <span>{user.address ? user.address : "N/A"}</span>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="step3 mt-5" data-intro="This is the your details">
              <Col sm="6" lg="4" className="order-sm-1 order-xl-0">
                <Row>
                  <Col md="6">
                    <div className="ttl-info text-start ttl-xs-mt">
                      <H6>
                        {/* <i className='fa fa-phone me-2'></i> */}
                        {"Gender"}
                      </H6>
                      <span>{user.gender}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="ttl-info text-start ttl-sm-mb-0">
                      <H6>
                        {/* <i className='fa fa-calendar me-2'></i> */}
                        {"Qualification"}
                      </H6>
                      <span>
                        {user.qualification ? user.qualification : "N/A"}
                      </span>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col sm="12" lg="4" className="order-sm-0 order-xl-1">
                {/* <div className='ttl-info text-start ttl-xs-mt'>
                      <H6>
                      
                        {"Gender"}
                      </H6>
                      <span>{user.gender}</span>
                    </div> */}
              </Col>
              <Col sm="6" lg="4" className="order-sm-2 order-xl-2">
                <Row>
                  <Col md="6">
                    <div className="ttl-info text-start ttl-xs-mt">
                      <H6>
                        {/* <i className='fa fa-phone me-2'></i> */}
                        {"Age"}
                      </H6>
                      <span>{user.age}</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="ttl-info text-start ttl-xs-mt"></div>
                    <div className='ttl-info text-start ttl-sm-mb-0'>
                      <H6>
                        <i className=' me-2'></i>
                        {'Adhaar'}
                      </H6>
                      <span>{user.aadhar_number? user.aadhar_number : "N/A"}</span>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr />
            {/* <div className='social-media step4' data-intro='This is your Social details'>
              <UL attrUL={{ horizontal: true, className: 'simple-list list-inline d-flex justify-content-center simple-list' }}>
                <LI attrLI={{ className: 'border-0 list-inline-item' }}>
                  <a href='https://www.facebook.com/'>
                    <i className='fa fa-facebook'></i>
                  </a>
                </LI>
                <LI attrLI={{ className: 'border-0  list-inline-item' }}>
                  <a href='https://accounts.google.com/'>
                    <i className='fa fa-google-plus'></i>
                  </a>
                </LI>
                <LI attrLI={{ className: 'border-0  list-inline-item' }}>
                  <a href='https://twitter.com/'>
                    <i className='fa fa-twitter'></i>
                  </a>
                </LI>
                <LI attrLI={{ className: 'border-0  list-inline-item' }}>
                  <a href='https://www.instagram.com/'>
                    <i className='fa fa-instagram'></i>
                  </a>
                </LI>
                <LI attrLI={{ className: 'border-0  list-inline-item' }}>
                  <a href='https://dashboard.rss.com/auth/sign-in/'>
                    <i className='fa fa-rss'></i>
                  </a>
                </LI>
              </UL>
            </div> */}
            <div className="follow">
              <Row>
                <Col
                  col="6"
                  className="border-end text-center d-flex align-items-center justify-content-center"
                >
                  <Button
                    className="edit d-flex gap-2"
                    color="info"
                    onClick={() => handleEdit()}
                  >
                    <span className="edit-span"> Edit Profile</span>
                    <span className="edit-icons">
                      <FiEdit2 />
                    </span>
                  </Button>
                  {/* <CountUp end={25869} className='follow-num counter d-grid' />
                  <span>{Follower}</span> */}
                </Col>
                <Col
                  col="6"
                  className="text-center d-flex align-items-center justify-content-center"
                >
                  <Button
                    className="edit d-flex gap-2"
                    color="warning"
                    onClick={toggle}
                  >
                    <span className="edit-span"> Change Password</span>
                    <span className="edit-icons">
                      <FiEdit2 />
                    </span>
                  </Button>
                  {/* <CountUp end={659887} className='follow-num counter d-grid' />
                  <span>{Following}</span> */}
                </Col>
              </Row>
            </div>
          </div>
        </Card>
      </Col>

      <Modal isOpen={modal} toggle={toggle} size="xl">
        <ModalHeader>{edit ? "Profile Update" : "Change Password"}</ModalHeader>
        <ModalBody>
          {edit && !isInvalidUserId && userId === 4 && (
            <Form
              onSubmit={handleSubmit(onSubmit)}
              className="form-bookmark needs-validation"
            >
              <Row>
                <Col sm="12" xl="6" className="custom-padding-lg">
                  <FormGroup className="mb-3">
                    {!base64 && (
                      <>
                        <Label htmlFor="fname">{"Image"}</Label>
                        <input
                          className={`form-control ${
                            errors.image && "is-invalid"
                          }`}
                          id="image"
                          type="file"
                          name="firstname"
                          accept=".jpg, .jpeg, .png"
                          defaultValue={formdata.image || ""}
                          {...register("image", { required: false })}
                          onChange={handleFileChange}
                        />
                        <span className="text-danger">
                          {errors.image && "Image is required"}
                        </span>
                      </>
                    )}
                    {base64 && (
                      <div>
                        <img
                          src={base64}
                          alt="Selected"
                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                        />
                      </div>
                    )}
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label htmlFor="fname">{FirstName}</Label>
                    <input
                      className={`form-control ${
                        errors.firstName && "is-invalid"
                      }`}
                      id="fname"
                      type="text"
                      name="firstname"
                      defaultValue={formdata.firstName || ""}
                      {...register("firstName", { required: false })}
                    />
                    <span className="text-danger">
                      {errors.firstName && "First name is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="lname">{LastName}</Label>
                    <input
                      className={`form-control ${
                        errors.lastname && "is-invalid"
                      }`}
                      id="lname"
                      type="text"
                      name="lastname"
                      defaultValue={formdata.lastname || ""}
                      {...register("lastname", { required: false })}
                    />
                    <span className="text-danger">
                      {errors.lastname && "Last name is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="mobilenumber">{MobileNo}</Label>
                    <input
                      className={`form-control ${errors.age && "is-invalid"}`}
                      id="phone"
                      type="number"
                      name="phone"
                      defaultValue={formdata.phone || ""}
                      {...register("phone", { required: false })}
                    />
                    <span className="text-danger">
                      {errors.age && "Age is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="Bdate">{BirthDate}</Label>
                    <Controller
                      control={control}
                      name="birthday"
                      render={({ field }) => (
                        <input
                          {...field}
                          className={`form-control ${
                            errors.birthday && "is-invalid"
                          }`}
                          id="Bdate"
                          type="date"
                          max={new Date().toISOString().split("T")[0]} // Ensure max date is today
                        />
                      )}
                    />
                    <span className="text-danger">
                      {errors.birthday && "Birth Date is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="age">{Age}</Label>
                    <input
                      className={`form-control ${errors.age && "is-invalid"}`}
                      id="age"
                      type="number"
                      name="age"
                      value={age}
                      disabled
                    />
                    <span className="text-danger">
                      {errors.age && "Age is required"}
                    </span>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="gender">Gender</Label>
                    <div className="d-flex gap-3">
                      <div className="custom-control custom-radio">
                        <Controller
                          name="gender"
                          control={control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <>
                              <Input
                                className="custom-control-input"
                                id="male"
                                type="radio"
                                value={
                                  user?.gender === "male" ? user?.gender : ""
                                }
                                checked={field.value === "male"}
                                onChange={() => field.onChange("male")}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="male"
                              >
                                Male
                              </Label>
                            </>
                          )}
                        />
                      </div>
                      <div className="custom-control custom-radio">
                        <Controller
                          name="gender"
                          control={control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <>
                              <Input
                                className="custom-control-input"
                                id="female"
                                type="radio"
                                value={
                                  user?.gender === "female" ? user?.gender : ""
                                }
                                checked={field.value === "female"}
                                onChange={() => field.onChange("female")}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="female"
                              >
                                Female
                              </Label>
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </FormGroup>
                </Col>
                <Col sm="12" xl="6" className="custom-padding-lg mb-3">
                  <FormGroup className="mb-3">
                    <Label htmlFor="address">{Address}</Label>
                    <Input
                      type="textarea"
                      className="form-control"
                      rows="3"
                      id="address"
                      name="address"
                      defaultValue={formdata.address || ""}
                      {...register("address", { required: false })}
                    />
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="email">"Email Address"</Label>
                    <input
                      className={`form-control ${errors.email && "is-invalid"}`}
                      id="email"
                      type="email"
                      name="email"
                      defaultValue={formdata.email || ""}
                      {...register("email", { required: false })}
                    />
                    {/* <span className="text-danger">{errors.email && "Email is required"}</span> */}
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="profession">{"Profession"}</Label>
                    <input
                      className={`form-control ${
                        errors.profession && "is-invalid"
                      }`}
                      id="profession"
                      type="text"
                      name="profession"
                      defaultValue={formdata.profession || ""}
                      {...register("profession", { required: false })}
                    />
                    <span className="text-danger">
                      {errors.profession && "profession is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="fname">{"Realation Contact Name"}</Label>
                    <input
                      className={`form-control ${
                        errors.contactName && "is-invalid"
                      }`}
                      id="contactname"
                      type="text"
                      name="contactname"
                      defaultValue={formdata.contactname || ""}
                      {...register("contactname", { required: false })}
                    />
                    <span className="text-danger">
                      {errors.contactname &&
                        "Realation Contact Name is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="relation">{ContactRelation}</Label>
                    <input
                      className={`form-control ${
                        errors.relation && "is-invalid"
                      }`}
                      id="relation"
                      type="text"
                      name="relation"
                      defaultValue={formdata.relation || ""}
                      {...register("relation", { required: false })}
                    />
                    {/* <span className="text-danger">{errors.firstName && "First name is required"}</span> */}
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="contactnumber">{ContactNo}</Label>
                    <input
                      className={`form-control ${
                        errors.contactnumber && "is-invalid"
                      }`}
                      id="contactnumber"
                      type="number"
                      name="contactnumber"
                      defaultValue={formdata.contactnumber || ""}
                      {...register("contactnumber", { required: false })}
                    />
                    {/* <span className="text-danger">{errors.contactnumber && "contactnumber is required"}</span> */}
                  </FormGroup>
                  <div className="text-end btn-mb">
                    <Button
                      type="submit"
                      color="primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Updating..." : "Update"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}

          {edit && !isInvalidUserId && userId === 3 && (
            <Form
              onSubmit={handleSubmit(onSubmit)}
              className="form-bookmark needs-validation"
            >
              <Row>
                <Col sm="12" xl="6" className="custom-padding-lg">
                  <FormGroup className="mb-3">
                    {!base64 && (
                      <>
                        <Label htmlFor="fname">{"Image"}</Label>
                        <input
                          className={`form-control ${
                            errors.image && "is-invalid"
                          }`}
                          id="image"
                          type="file"
                          name="firstname"
                          accept=".jpg, .jpeg, .png"
                          defaultValue={formdata.image || ""}
                          {...register("image", { required: false })}
                          onChange={handleFileChange}
                        />
                        <span className="text-danger">
                          {errors.image && "Image is required"}
                        </span>
                      </>
                    )}
                    {base64 && (
                      <div>
                        <img
                          src={base64}
                          alt="Selected"
                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                        />
                        {/* <textarea readOnly value={base64} rows="4" cols="50" /> */}
                      </div>
                    )}
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="fname">{FirstName}</Label>
                    <input
                      className={`form-control ${
                        errors.firstName && "is-invalid"
                      }`}
                      id="fname"
                      type="text"
                      name="firstname"
                      defaultValue={user?.first_name || ""}
                      {...register("firstName", { required: false })}
                    />
                    <span className="text-danger">
                      {errors.firstName && "First name is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="lname">{LastName}</Label>
                    <input
                      className={`form-control ${
                        errors.lastname && "is-invalid"
                      }`}
                      id="lname"
                      type="text"
                      name="lastname"
                      defaultValue={user?.surname || ""}
                      {...register("lastname", { required: false })}
                    />
                    <span className="text-danger">
                      {errors.lastname && "Last name is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="mobilenumber">{MobileNo}</Label>
                    <input
                      className={`form-control ${errors.phone && "is-invalid"}`}
                      id="phone"
                      type="number"
                      name="phone"
                      maxLength={10}
                      defaultValue={user?.phone || ""}
                      {...register("phone", {
                        required: false,
                        minLength: {
                          value: 10,
                          message: "Phone number must be at least 10 digits",
                        },
                        maxLength: {
                          value: 10,
                          message: "Phone number must be exactly 10 digits",
                        },
                        pattern: {
                          value: /^[0-9]+$/,
                          message: "Phone number must contain only digits",
                        },
                      })}
                    />
                    <span className="text-danger">
                      {errors.age && "MobileNo is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="Bdate">{BirthDate}</Label>
                    <Controller
                      control={control}
                      name="birthday"
                      render={({ field }) => (
                        <input
                          {...field}
                          className={`form-control ${
                            errors.birthday && "is-invalid"
                          }`}
                          id="Bdate"
                          type="date"
                          max={new Date().toISOString().split("T")[0]} // Ensure max date is today
                        />
                      )}
                    />
                    <span className="text-danger">
                      {errors.birthday && "Birth Date is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="age">{Age}</Label>
                    <input
                      className={`form-control ${errors.age && "is-invalid"}`}
                      id="age"
                      type="number"
                      name="age"
                      value={age}
                      disabled
                    />
                    <span className="text-danger">
                      {errors.age && "Age is required"}
                    </span>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="gender">Gender</Label>
                    <div className="d-flex gap-3">
                      <div className="custom-control custom-radio">
                        <Controller
                          name="gender"
                          control={control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <>
                              <Input
                                className="custom-control-input"
                                id="male"
                                type="radio"
                                value={
                                  user?.gender === "male" ? user?.gender : ""
                                }
                                checked={field.value === "male"}
                                onChange={() => field.onChange("male")}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="male"
                              >
                                Male
                              </Label>
                            </>
                          )}
                        />
                      </div>
                      <div className="custom-control custom-radio">
                        <Controller
                          name="gender"
                          control={control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <>
                              <Input
                                className="custom-control-input"
                                id="female"
                                type="radio"
                                value={
                                  user?.gender === "female" ? user?.gender : ""
                                }
                                checked={field.value === "female"}
                                onChange={() => field.onChange("female")}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="female"
                              >
                                Female
                              </Label>
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </FormGroup>
                </Col>
                <Col sm="12" xl="6" className="custom-padding-lg mb-3">
                  <FormGroup className="mb-3">
                    <Label htmlFor="address">{Address}</Label>
                    <input
                      type="textarea"
                      className={`form-control ${errors.addr && "is-invalid"}`}
                      rows="3"
                      id="addr"
                      name="addr"
                      defaultValue={user?.address || ""}
                      {...register("addr", { required: false })}
                    />
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="email">{"Email Address"}</Label>
                    <input
                      className={`form-control ${errors.email && "is-invalid"}`}
                      id="email"
                      type="email"
                      name="email"
                      defaultValue={user?.email || ""}
                      {...register("email", { required: false })}
                    />
                    {/* <span className="text-danger">{errors.email && "Email is required"}</span> */}
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="qualification">{"Qualification"}</Label>
                    <input
                      className={`form-control ${
                        errors.profession && "is-invalid"
                      }`}
                      id="qualification"
                      type="text"
                      name="qualification"
                      defaultValue={user?.qualification || ""}
                      {...register("qualification", { required: false })}
                    />
                    <span className="text-danger">
                      {errors.qualification && "qualification is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="aadharnumber">{"AadharNumber"} </Label>
                    <input
                      className={`form-control ${
                        errors.aadharnumber && "is-invalid"
                      }`}
                      id="aadharnumber"
                      type="number"
                      name="aadharnumber"
                      maxLength="12"
                      defaultValue={user?.aadhar_number || ""}
                      {...register("aadharnumber", { required: false })}
                    />
                    {/* <span className="text-danger">{errors.contactnumber && "contactnumber is required"}</span> */}
                  </FormGroup>
                  <div className="text-end btn-mb mt-5">
                    <Button
                      type="submit"
                      color="primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Updating..." : "Update"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}

          {edit && !isInvalidUserId && userId === 2 && (
            <Form
              onSubmit={handleSubmit(onSubmit)}
              className="theme-form login-form needs-validation"
            >
              <Row>
                <Col sm="12" xl="6" className="custom-padding-lg">
                  <FormGroup className="mb-3">
                    {!base64 && (
                      <>
                        <Label htmlFor="fname">{"Image"}</Label>
                        <input
                          className={`form-control ${
                            errors.image && "is-invalid"
                          }`}
                          id="image"
                          type="file"
                          name="firstname"
                          accept=".jpg, .jpeg, .png"
                          defaultValue={formdata.image || ""}
                          {...register("image", { required: false })}
                          onChange={handleFileChange}
                        />
                        <span className="text-danger">
                          {errors.image && "Image is required"}
                        </span>
                      </>
                    )}
                    {base64 && (
                      <div>
                        <img
                          src={base64}
                          alt="Selected"
                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                        />
                      </div>
                    )}
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label htmlFor="fname">{FirstName}</Label>
                    <input
                      className={`form-control ${
                        errors.firstName && "is-invalid"
                      }`}
                      id="fname"
                      type="text"
                      name="firstname"
                      defaultValue={user?.first_name || ""}
                      {...register("firstName", { required: false })}
                    />
                    <span className="text-danger">
                      {errors.firstName && "First name is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="lname">{LastName}</Label>
                    <input
                      className={`form-control ${
                        errors.lastname && "is-invalid"
                      }`}
                      id="lname"
                      type="text"
                      name="lastname"
                      defaultValue={user?.surname || ""}
                      {...register("lastname", { required: false })}
                    />
                    <span className="text-danger">
                      {errors.lastname && "Last name is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="mobilenumber">{MobileNo}</Label>
                    <input
                      className={`form-control ${errors.phone && "is-invalid"}`}
                      id="phone"
                      type="number"
                      name="phone"
                      maxLength={10}
                      defaultValue={user?.phone || ""}
                      {...register("phone", {
                        required: false,
                        minLength: {
                          value: 10,
                          message: "Phone number must be at least 10 digits",
                        },
                        maxLength: {
                          value: 10,
                          message: "Phone number must be exactly 10 digits",
                        },
                        pattern: {
                          value: /^[0-9]+$/,
                          message: "Phone number must contain only digits",
                        },
                      })}
                    />
                    <span className="text-danger">
                      {errors.phone && "MobileNo is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="Bdate">{BirthDate}</Label>
                    <Controller
                      control={control}
                      name="birthday"
                      render={({ field }) => (
                        <input
                          {...field}
                          className={`form-control ${
                            errors.birthday && "is-invalid"
                          }`}
                          id="Bdate"
                          type="date"
                          max={new Date().toISOString().split("T")[0]}
                        />
                      )}
                    />
                    <span className="text-danger">
                      {errors.birthday && "Birth Date is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="age">{Age}</Label>
                    <input
                      className={`form-control ${errors.age && "is-invalid"}`}
                      id="age"
                      type="number"
                      name="age"
                      value={user?.age ? user.age : age}
                      disabled
                    />
                    <span className="text-danger">
                      {errors.age && "Age is required"}
                    </span>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="gender">Gender</Label>
                    <div className="d-flex gap-3">
                      <div className="custom-control custom-radio">
                        <Controller
                          name="gender"
                          control={control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <>
                              <Input
                                className="custom-control-input"
                                id="male"
                                type="radio"
                                value={
                                  user?.gender === "male" ? user?.gender : ""
                                }
                                checked={field.value === "male"}
                                onChange={() => field.onChange("male")}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="male"
                              >
                                Male
                              </Label>
                            </>
                          )}
                        />
                      </div>
                      <div className="custom-control custom-radio">
                        <Controller
                          name="gender"
                          control={control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <>
                              <Input
                                className="custom-control-input"
                                id="female"
                                type="radio"
                                value={
                                  user?.gender === "female" ? user?.gender : ""
                                }
                                checked={field.value === "female"}
                                onChange={() => field.onChange("female")}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="female"
                              >
                                Female
                              </Label>
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </FormGroup>
                </Col>
                <Col sm="12" xl="6" className="custom-padding-lg mb-3">
                  <FormGroup className="mb-3">
                    <Label htmlFor="address">{Address}</Label>
                    <input
                      type="textarea"
                      className={`form-control ${
                        errors.address && "is-invalid"
                      }`}
                      rows="3"
                      id="address"
                      name="address"
                      defaultValue={user?.address || ""}
                      {...register("address", { required: false })}
                    />
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="email">{"Email Address"}</Label>
                    <input
                      className={`form-control ${errors.email && "is-invalid"}`}
                      id="email"
                      type="email"
                      name="email"
                      defaultValue={user?.email || ""}
                      {...register("email", { required: false })}
                    />
                    {/* <span className="text-danger">{errors.email && "Email is required"}</span> */}
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="qualification">{"Qualification"}</Label>
                    <input
                      className={`form-control ${
                        errors.profession && "is-invalid"
                      }`}
                      id="qualification"
                      type="text"
                      name="qualification"
                      defaultValue={user?.qualification || ""}
                      {...register("qualification", { required: false })}
                    />
                    <span className="text-danger">
                      {errors.qualification && "qualification is required"}
                    </span>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="aadharnumber">{"AadharNumber"} </Label>
                    <input
                      className={`form-control ${
                        errors.aadharnumber && "is-invalid"
                      }`}
                      id="aadharnumber"
                      type="number"
                      name="aadharnumber"
                      maxLength="12"
                      defaultValue={user?.aadhar_number || ""}
                      {...register("aadharnumber", { required: false })}
                    />
                    {/* <span className="text-danger">{errors.contactnumber && "contactnumber is required"}</span> */}
                  </FormGroup>
                  <div className="text-end btn-mb mt-5">
                    <Button
                      type="submit"
                      color="primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Updating..." : "Update"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}

          {edit && !isInvalidUserId && userId === 1 && (
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-5 mt-3 text-center">
                <b>Profile Image</b>
                <div
                  className="profileContainer"
                  style={{
                    backgroundColor: "#F4F4F4",
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    cursor: "pointer",
                    margin: "auto",
                  }}
                >
                  {/* Replace with image handling logic */}
                  <img
                    src={base64 || watch("image") || user.image}
                    alt="Profile"
                    className="profileImage"
                    style={{
                      width: "100px",
                      height: "100px",
                      borderRadius: "50%",
                    }}
                  />
                </div>
                <FormGroup>
                  <Input
                    type="file"
                    id="profileImageInput"
                    onChange={handleFileChange}
                  />
                </FormGroup>
              </div>

              <div className="row px-5">
                <FormGroup className="mb-3">
                  <Label htmlFor="fname">{FirstName}</Label>
                  <input
                    className={`form-control ${
                      errors.firstName && "is-invalid"
                    }`}
                    id="fname"
                    type="text"
                    name="firstname"
                    defaultValue={formdata.firstName || ""}
                    {...register("firstName", { required: false })}
                  />
                  <span className="text-danger">
                    {errors.firstName && "First name is required"}
                  </span>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label htmlFor="lname">{LastName}</Label>
                  <input
                    className={`form-control ${
                      errors.lastname && "is-invalid"
                    }`}
                    id="lname"
                    type="text"
                    name="lastname"
                    defaultValue={formdata.lastname || ""}
                    {...register("lastname", { required: false })}
                  />
                  <span className="text-danger">
                    {errors.lastname && "Last name is required"}
                  </span>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label htmlFor="mobilenumber">{MobileNo}</Label>
                  <input
                    className={`form-control ${errors.age && "is-invalid"}`}
                    id="phone"
                    type="number"
                    name="phone"
                    defaultValue={formdata.phone || ""}
                    {...register("phone", { required: false })}
                  />
                  <span className="text-danger">
                    {errors.age && "Phone Number is required"}
                  </span>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label htmlFor="qualification">{"Qualification"}</Label>
                  <input
                    className={`form-control ${
                      errors.profession && "is-invalid"
                    }`}
                    id="qualification"
                    type="text"
                    name="qualification"
                    defaultValue={formdata.qualification || ""}
                    {...register("qualification", { required: false })}
                  />
                  <span className="text-danger">
                    {errors.profession && "qualification is required"}
                  </span>
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label htmlFor="email">Email Address</Label>
                  <input
                    className={`form-control ${errors.email && "is-invalid"}`}
                    id="email"
                    type="email"
                    name="email"
                    defaultValue={formdata.email || ""}
                    {...register("email", { required: false })}
                  />
                  {/* <span className="text-danger">{errors.email && "Email is required"}</span> */}
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label htmlFor="address">{Address}</Label>
                  <Input
                    type="text"
                    className="form-control"
                    rows="3"
                    id="address"
                    name="address"
                    defaultValue={formdata.address || ""}
                    {...register("address", { required: false })}
                  />
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label htmlFor="Bdate">{BirthDate}</Label>
                  <Controller
                    control={control}
                    name="birthday"
                    render={({ field }) => (
                      <input
                        {...field}
                        className={`form-control ${
                          errors.birthday && "is-invalid"
                        }`}
                        id="Bdate"
                        type="date"
                        max={new Date().toISOString().split("T")[0]} // Ensure max date is today
                      />
                    )}
                  />
                  <span className="text-danger">
                    {errors.birthday && "Birth Date is required"}
                  </span>
                </FormGroup>
                <FormGroup className="mb-3">
                  <Label htmlFor="age">{Age}</Label>
                  <input
                    className={`form-control ${errors.age && "is-invalid"}`}
                    id="age"
                    type="number"
                    name="age"
                    value={age}
                    disabled
                  />
                  <span className="text-danger">
                    {errors.age && "Age is required"}
                  </span>
                </FormGroup>

                <FormGroup>
                  <Label htmlFor="gender">Gender</Label>

                  <div className="d-flex gap-3">
                    <div className="custom-control custom-radio">
                      <Controller
                        name="gender"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => (
                          <>
                            <Input
                              className="custom-control-input"
                              id="male"
                              type="radio"
                              value={user?.gender === "Male" ? "male" : ""}
                              checked={field.value === "male"}
                              onChange={() => field.onChange("male")}
                            />
                            <Label
                              className="custom-control-label"
                              htmlFor="male"
                            >
                              Male
                            </Label>
                          </>
                        )}
                      />
                    </div>
                    <div className="custom-control custom-radio">
                      <Controller
                        name="gender"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => (
                          <>
                            <Input
                              className="custom-control-input"
                              id="female"
                              type="radio"
                              value={user?.gender === "Female" ? "female" : ""}
                              checked={field.value === "female"}
                              onChange={() => field.onChange("female")}
                            />
                            <Label
                              className="custom-control-label"
                              htmlFor="female"
                            >
                              Female
                            </Label>
                          </>
                        )}
                      />
                    </div>
                  </div>
                </FormGroup>
                <FormGroup className="mb-3">
                    <Label htmlFor="aadharnumber">{"AadharNumber"} </Label>
                    <input
                      className={`form-control ${
                        errors.aadharnumber && "is-invalid"
                      }`}
                      id="aadharnumber"
                      type="number"
                      name="aadharnumber"
                      maxLength="12"
                      defaultValue={user?.aadhar_number || ""}
                      {...register("aadharnumber", { required: false })}
                    />
                    {/* <span className="text-danger">{errors.contactnumber && "contactnumber is required"}</span> */}
                  </FormGroup>
              </div>

              <Button type="submit" color="primary" disabled={isSubmitting}>
                {isSubmitting ? "Updating..." : "Update"}
              </Button>
            </Form>
          )}

          {!edit && (
            <Form onSubmit={handleSubmit(onSubmit)}>
              <FormGroup>
                <Label for="newPassword">New Password</Label>
                <Controller
                  name="newPassword"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "New password is required",
                    minLength: {
                      value: 6,
                      message: "Password must be at least 6 characters",
                    },
                  }}
                  render={({ field }) => <Input type="password" {...field} />}
                />
                {errors.newPassword && (
                  <p className="text-danger">{errors.newPassword.message}</p>
                )}
              </FormGroup>
              <FormGroup>
                <Label for="confirmPassword">Confirm Password</Label>
                <Controller
                  name="confirmPassword"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Please confirm your password",
                    validate: (value) =>
                      value === password || "Passwords do not match",
                  }}
                  render={({ field }) => <Input type="password" {...field} />}
                />
                {errors.confirmPassword && (
                  <p className="text-danger">
                    {errors.confirmPassword.message}
                  </p>
                )}
              </FormGroup>
              <Button type="submit" color="primary" disabled={isSubmitting}>
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Form>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleCancel}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default UserProfile;
